module.exports = __webpack_public_path__ + "static/media/no-contact-hero.86f9550b.png";